import {connect} from "react-redux";
import Notifications from "./Notifications";
import {bindActionCreators} from "redux";
import {getNotification} from "../../service/Notification/action";

const mapStateToProps = (state) => ({
    notificationDetails:state.NotificationReducer.notificationDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getNotification,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
